import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  getPublicChallengeBySlugV3ResponseSchema,
  type IChallengeV3,
} from './get-public-challenge-by-slug-v3-response';

/**
 * @deprecated Superseded by `getPublicChallengeBySlugV4Api` (app) / `V5` (web).
 * Frozen, not deleted - an old app binary may still call it. See "Web-only /
 * orphan versions pending deletion" in apps/api/CLAUDE.md.
 */
export async function getPublicChallengeBySlugV3Api(slug: string) {
  return getRequest<IAPI<IChallengeV3>>({
    path: `/challenges/v3/slug/${encodeURIComponent(slug)}`,
    schema: getPublicChallengeBySlugV3ResponseSchema,
  });
}
